import { Spinner } from '@/components/Spinner';
import { useReferralStageDetail } from './hooks/useReferralStageDetail';
import { ManageReferralStage } from './ManageReferralStage';
import { ManageReferralStageTwo } from './ManageReferralStageTwo';

export const ManageReferralStageContainer = ({ stageId, index }: { stageId: string; index: number }) => {
  const { referralStage, loading } = useReferralStageDetail(stageId);
  const stageOneDefaultValues = {
    stageTitle: referralStage?.stageTitle ?? '',
    firstVisitRewardPoint: String(referralStage?.firstVisitRewardPoint ?? 0),
    secondVisitRewardPoint: String(referralStage?.secondVisitRewardPoint ?? 0),
    thirdVisitRewardPoint: String(referralStage?.thirdVisitRewardPoint ?? 0),
  };
  const stageTwoDefaultValues = {
    stageTitle: referralStage?.stageTitle ?? '',
    stageTwoRewardPoint: String(referralStage?.stageTwoRewardPoint ?? 0),
  };
  const FormComponent =
    index === 0 ? (
      <ManageReferralStage defaultValues={stageOneDefaultValues} stageId={stageId} />
    ) : (
      <ManageReferralStageTwo defaultValues={stageTwoDefaultValues} stageId={stageId} />
    );
  return loading ? <Spinner /> : FormComponent;
};
